import {BgHamburger} from "../../../components";

export function headerScripts(): void {
    const countryButton = document.querySelectorAll(".ec-header-site-selector")
    const countryDropDown = document.querySelectorAll(".ec-header-country-dropdown")
    const mobileMenuButton = document.getElementById("ec-header-mobile-menu-button")
    const mobileMenu = document.getElementById("ec-header-mobile-menu")
    const menuItems = document.querySelectorAll(".ec-header-mobile-menu-item[data-target]");
    const backButtons = document.querySelectorAll(".ec-mobile-menu-back");

    if (countryButton.length > 0) {
        countryButton.forEach(button => {
            button.addEventListener("click", () => {
                button.parentElement?.querySelector(".ec-header-country-dropdown")?.classList.toggle("ec-header-item-hidden");
            })
        })
    }

    mobileMenuButton?.addEventListener('bg-hamburger-toggle', () => {
        if (mobileMenu) {
            if (mobileMenu.getAttribute("menu-open") != "true") {
                mobileMenu.classList.add("ec-header-show")
                mobileMenu.setAttribute("menu-open", "true")
            } else {
                resetMenuToMain()
                mobileMenu.classList.remove("ec-header-show");
                mobileMenu.setAttribute("menu-open", "false");
            }
        }
    })


    document.addEventListener("scroll", () => {
        countryDropDown.forEach(dropdown => {
            if (dropdown && !dropdown?.classList.contains("ec-header-item-hidden")) {
                dropdown?.classList.add("ec-header-item-hidden");
            }
        })
    })

    document.addEventListener("click", (e) => {
        const menu = document.getElementById("ec-header-mobile-menu");
        const search = document.getElementById("ec-header-search");
        let searchIcon = document.querySelectorAll(".ec-header-search-menu-icon")
        countryDropDown.forEach(dropdown => {

            if (dropdown && !dropdown?.classList.contains("ec-header-item-hidden") && (e.target as HTMLElement).getAttribute("id") !== "country-button") {
                dropdown?.classList.add("ec-header-item-hidden");
            }
        })
        if (menu?.getAttribute("menu-open") === "true" && !menu.contains(e.target as Node) && e.target != mobileMenuButton) {
            resetMenuToMain();
            menu.classList.remove("ec-header-show");
            menu.setAttribute("menu-open", "false");
            if(mobileMenuButton){
                (mobileMenuButton as BgHamburger).close();
            }
        }
        if (search && search.classList.contains("ec-header-show") && !(e.target as HTMLElement).classList.contains("ec-header-search-menu-icon") && !(e.target as HTMLElement).closest('#ec-header-search')) {
            search.classList.remove("ec-header-show")
            searchIcon.forEach(icon => {
                icon.classList.remove("bg-header-item-active")
            })

        }
        updateHtmlScrollLock()
    });

    menuItems.forEach(item => {
        item.addEventListener("click", () => {
            const targetId = item.getAttribute("data-target");
            if (targetId) {
                document.querySelectorAll(".ec-mobile-menu-level").forEach(menu => {
                    menu.classList.remove("active");
                });
                document.getElementById(targetId)?.classList.add("active");
            }
        });
    });

    backButtons.forEach(back => {
        back.addEventListener("click", () => {
            const backId = back.getAttribute("data-back");
            if (backId) {
                document.querySelectorAll(".ec-mobile-menu-level").forEach(menu => {
                    menu.classList.remove("active");
                });
                document.getElementById(backId)?.classList.add("active");
            }
        });
    });

    function resetMenuToMain() {
        document.querySelectorAll(".ec-mobile-menu-level").forEach(menu => {
            menu.classList.remove("active");
        });
        document.getElementById("menu-main")?.classList.add("active");
    }

    let megaMenuHeadingLinks = document.querySelectorAll(".ec-header-parent-nav-link");
    let htmlElement = document.querySelector("html");

    function updateHtmlScrollLock() {

        if (htmlElement) {
            const anyMenuVisible = [...document.querySelectorAll(".ec-mega-menu")]
                .some(menu => menu.classList.contains("ec-header-show"));
            htmlElement.style.overflow = anyMenuVisible ? "hidden" : "visible";
        }
    }

    megaMenuHeadingLinks.forEach(item => {
        let timer;
        let itemId = item.getAttribute("id");
        let megaMenu = document.getElementById("menu-" + itemId);

        item.addEventListener('mouseenter', () => {
            clearTimeout(timer);

            document.querySelectorAll(".ec-header-show").forEach(menu => {
                menu.classList.remove("ec-header-show");
            });

            document.querySelectorAll(".bg-header-item-active").forEach(menu => {
                menu.classList.remove("bg-header-item-active");
            });

            megaMenu?.classList.add("ec-header-show");
            updateHtmlScrollLock();
        });

        item.addEventListener('mouseleave', () => {
            timer = setTimeout(() => {
                megaMenu?.classList.remove("ec-header-show");
                updateHtmlScrollLock();
            }, 400);
        });

        megaMenu?.addEventListener('mouseenter', () => {
            clearTimeout(timer);
        });

        megaMenu?.addEventListener('mouseleave', () => {
            timer = setTimeout(() => {
                megaMenu?.classList.remove("ec-header-show");
                updateHtmlScrollLock();
            }, 400);
        });
    });

    let searchIcon = document.querySelectorAll(".ec-header-search-menu-icon")
    let headerSearch = document.getElementById("ec-header-search");
    let headerSearchClose = document.getElementById("ec-header-seach-close-icon");
    searchIcon.forEach(icon => {
        icon.addEventListener('click', () => {
            if (headerSearch) {
                headerSearch.classList.toggle("ec-header-show");
                icon.classList.toggle("bg-header-item-active")

            }
        })
    })
    headerSearchClose?.addEventListener('click', () => {
        if (headerSearch) {
            headerSearch.classList.remove("ec-header-show");
        }
    })

    const dropDownMenu = document.querySelector('.bg-header-menu-dropdown');

    if (dropDownMenu) {
        dropDownMenu.addEventListener("mouseover", () => {
            const dropdownList = dropDownMenu.querySelector('.ec-header-menu-dropdown-menu');
            if (dropdownList) {
                if (dropdownList.classList.contains('ec-header-item-hidden')) {
                    dropdownList.classList.remove("ec-header-item-hidden");
                }
            }
        })
        dropDownMenu.addEventListener("mouseleave", () => {
            const dropdownList = dropDownMenu.querySelector('.ec-header-menu-dropdown-menu');
            if (dropdownList) {
                if (!dropdownList.classList.contains('ec-header-item-hidden')) {
                    dropdownList.classList.add("ec-header-item-hidden");
                }
            }
        })
    }
}